import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { RoutePaths } from "../utils/Items";
import useConfig from "./useConfig";
import { useStore } from "./useStore";
import useTabs from "./useTabs";
import {
  handleActiveElement
} from "../utils/validations/keyboardShortcutsValidation";

const useKeyboardShortcuts = () => {
  const history = useHistory();
  const { tabStore } = useStore();
  const { openDialogOnHold } = useConfig();
  const { selectPrev, selectNext } = useTabs();

  useEffect(() => {
    document.addEventListener("keydown", redirectKeyboard);
    return () => {
      document.removeEventListener("keydown", redirectKeyboard);
    };
  });

  const redirectKeyboard = (e: any) => {
    if ((e.keyCode === 49 && e.altKey) || (e.keyCode === 97 && e.altKey)) {
      const activeElement: HTMLElement = document.activeElement as HTMLElement;
      handleActiveElement({
        activeElement: activeElement,
        action: () => redirectTo(RoutePaths.SearchManualInput)
      })
    }
    if ((e.keyCode === 50 && e.altKey) || (e.keyCode === 98 && e.altKey)) {
      const activeElement: any = document.activeElement;
      handleActiveElement({
        activeElement: activeElement,
        action: () => redirectTo(RoutePaths.Scan)
      })
    }
    if ((e.keyCode === 51 && e.altKey) || (e.keyCode === 99 && e.altKey)) {
      const activeElement: any = document.activeElement;
      handleActiveElement({
        activeElement: activeElement,
        action: () => redirectTo(RoutePaths.PendingRequest)
      })
    }
    if ((e.keyCode === 52 && e.altKey) || (e.keyCode === 100 && e.altKey)) {
      const activeElement: any = document.activeElement;
      handleActiveElement({
        activeElement: activeElement,
        action: () => redirectTo(RoutePaths.RegisterExit)
      })
    }
    if ((e.keyCode === 53 && e.altKey) || (e.keyCode === 101 && e.altKey)) {
      const activeElement: any = document.activeElement;
      handleActiveElement({
        activeElement: activeElement,
        action: () => selectPrev()
      })
    }
    if ((e.keyCode === 54 && e.altKey) || (e.keyCode === 102 && e.altKey)) {
      const activeElement: any = document.activeElement;
      handleActiveElement({
        activeElement: activeElement,
        action: () => selectNext()
      })
    }
  };

  const redirectTo = (route: string) => {
    if (tabStore.tabSelectIndex !== "-1") {
      openDialogOnHold({ route });
    } else {
      history.push(route);
    }
  };

  return { redirectKeyboard };
};

export default useKeyboardShortcuts;
